// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Flower inventory (redesign) — /inventory.
   Depends on dashboard-redesign.css for the shell tokens and shared
   .rf-btn / .rf-num / .rf-spacer / .rf-empty / .rf-segmented. */

.iv-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* .rf-content top-aligns rather than capping height — bind to the
     viewport minus the 64px top bar and the .rf-app gutter + border so
     the toolbar stays put and the flower table scrolls inside its card. */
  height: calc(100vh - 76px);
}

/* ---------------- toolbar ---------------- */
.iv-bar {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

/* the day stepper: this list is read one day at a time, so ‹ › matter
   more than a calendar — the legacy page offered only the calendar */
.iv-day {
  height: 34px;
  display: flex;
  align-items: center;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.iv-step {
  width: 30px;
  align-self: stretch;
  border: none;
  background: #fff;
  color: #6f6a60;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
}
.iv-step:hover {
  background: #f6f4ef;
  color: #191714;
}
.iv-day input {
  border: none;
  outline: none;
  background: none;
  height: 100%;
  padding: 0 8px;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  font-variant-numeric: tabular-nums;
  border-left: 1px solid #f0ece3;
  border-right: 1px solid #f0ece3;
  width: 124px;
}
.iv-day input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.5;
}
.iv-day input::-webkit-calendar-picker-indicator:hover {
  opacity: 0.9;
}
.iv-today {
  height: 34px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  color: #4a453c;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
}
.iv-today:hover:not(:disabled) {
  background: #f6f4ef;
}
.iv-today:disabled {
  opacity: 0.4;
  cursor: default;
}

.iv-search {
  height: 34px;
  min-width: 190px;
  flex-grow: 1;
  max-width: 300px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.iv-search:focus-within {
  border-color: #d8c9a4;
}
.iv-search input {
  border: none;
  outline: none;
  background: none;
  width: 100%;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.iv-search-icon {
  width: 11px;
  height: 11px;
  border: 1.6px solid #a29b8d;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}
.iv-search-icon::after {
  content: "";
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: 5px;
  height: 1.6px;
  background: #a29b8d;
  transform: rotate(45deg);
}

/* ---------------- body ---------------- */
.iv-body {
  flex-grow: 1;
  min-height: 0;
  padding: 18px 28px 26px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.iv-headline {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}
.iv-headline-main {
  min-width: 0;
}
.iv-eyebrow {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
}
.iv-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 25px;
  font-weight: 400;
  line-height: 1.15;
  color: #191714;
  margin: 2px 0 0;
}
.iv-title-rel {
  font-size: 12.5px;
  color: #8b8477;
  margin: 3px 0 0;
}

/* three totals that answer "how much do I buy" without adding the
   column up by hand */
.iv-kpis {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.iv-kpi {
  min-width: 120px;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 11px;
  padding: 9px 14px;
}
.iv-kpi-k {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
  white-space: nowrap;
}
.iv-kpi-v {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 23px;
  line-height: 1.15;
  color: #191714;
  font-variant-numeric: tabular-nums;
  margin-top: 1px;
}
.iv-kpi-v small {
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: #a29b8d;
  margin-left: 3px;
}
.iv-kpi-sub {
  font-size: 11px;
  color: #a29b8d;
  margin-top: 1px;
  overflow-wrap: anywhere;
}

/* The legacy caution box was a red sentence in a plain shadow box. It is
   the one thing on this page that can make the numbers wrong, so it says
   what to do about it. */
.iv-warn {
  flex-shrink: 0;
  display: flex;
  gap: 11px;
  padding: 11px 14px;
  border-radius: 11px;
  background: #f9f1de;
  border: 1px solid #ecdcb4;
}
.iv-warn-ic {
  flex-shrink: 0;
  font-size: 17px;
  color: #b0872f;
  line-height: 1.3;
}
.iv-warn-t {
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--rf-brand-deep);
}
.iv-warn-t b {
  font-weight: 700;
}
.iv-warn-link {
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  color: var(--rf-brand);
  border-bottom: 1px solid #d9c79c;
  cursor: pointer;
}
.iv-warn-link:hover {
  color: var(--rf-brand-hover);
  border-bottom-color: var(--rf-brand);
}

/* ---------------- table ---------------- */
.iv-tablewrap {
  flex-grow: 1;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.iv-scroll {
  flex-grow: 1;
  overflow-y: auto;
  min-height: 0;
}
.iv-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.iv-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #474339;
  color: #f2efe8;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  text-align: left;
  padding: 9px 14px;
  white-space: nowrap;
  border: none;
}
.iv-sort {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.iv-sort:hover {
  color: #fff;
}
.iv-sort-ar {
  font-size: 9px;
  opacity: 0.85;
}
.iv-sort.is-off .iv-sort-ar {
  visibility: hidden;
}
.iv-table tbody td {
  padding: 9px 14px;
  border-bottom: 1px solid #f0ece3;
  color: #4a453c;
  vertical-align: middle;
}
.iv-table tbody tr:last-child td {
  border-bottom: none;
}
.iv-row:hover > td {
  background: #fdfbf6;
}
.iv-c-num {
  width: 46px;
  text-align: right;
  color: #bdb6a7;
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
}
.iv-c-name {
  font-weight: 600;
  color: #191714;
  overflow-wrap: anywhere;
}
.iv-c-qty {
  width: 90px;
  text-align: right;
  font-weight: 700;
  color: #191714;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
/* the share bar makes the two or three flowers that dominate the day
   obvious without reading every number */
.iv-c-share {
  width: 34%;
  min-width: 130px;
}
.iv-track {
  height: 7px;
  border-radius: 999px;
  background: #f0ece3;
  overflow: hidden;
}
.iv-track > span {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--rf-brand-lite);
}
.iv-row.is-top .iv-track > span {
  background: var(--rf-brand);
}
.iv-pct {
  font-size: 10.5px;
  color: #bdb6a7;
  font-variant-numeric: tabular-nums;
  margin-top: 3px;
  display: block;
}

.iv-foot {
  border-top: 1px solid #f0ece3;
  background: #fdfcfa;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
  font-size: 11.5px;
  color: #a29b8d;
  font-variant-numeric: tabular-nums;
}

/* ---------------- states ---------------- */
.iv-state {
  padding: 44px 20px;
  text-align: center;
  font-size: 13px;
  color: #8b8477;
  line-height: 1.6;
}
.iv-state b {
  display: block;
  font-size: 14.5px;
  font-weight: 600;
  color: #4a453c;
  margin-bottom: 3px;
}
.iv-state .rf-btn {
  margin-top: 12px;
}
.iv-skel {
  height: 13px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f2efe8 25%, #f8f6f1 50%, #f2efe8 75%);
  background-size: 300% 100%;
  animation: iv-shimmer 1.3s linear infinite;
}
@keyframes iv-shimmer {
  from {
    background-position: 150% 0;
  }
  to {
    background-position: -150% 0;
  }
}

@media (max-width: 860px) {
  .iv-bar,
  .iv-body {
    padding-left: 16px;
    padding-right: 16px;
  }
  .iv-c-share {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/inventory.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB;;0EAEwE;EACxE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;qEACqE;AACrE;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gEAAgE;EAChE,cAAc;EACd,kCAAkC;EAClC,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gEAAgE;EAChE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;sBACsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,4DAA4D;EAC5D,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;;yBAEyB;AACzB;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;yCACyC;AACzC;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Flower inventory (redesign) — /inventory.\n   Depends on dashboard-redesign.css for the shell tokens and shared\n   .rf-btn / .rf-num / .rf-spacer / .rf-empty / .rf-segmented. */\n\n.iv-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  /* .rf-content top-aligns rather than capping height — bind to the\n     viewport minus the 64px top bar and the .rf-app gutter + border so\n     the toolbar stays put and the flower table scrolls inside its card. */\n  height: calc(100vh - 76px);\n}\n\n/* ---------------- toolbar ---------------- */\n.iv-bar {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n/* the day stepper: this list is read one day at a time, so ‹ › matter\n   more than a calendar — the legacy page offered only the calendar */\n.iv-day {\n  height: 34px;\n  display: flex;\n  align-items: center;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n}\n.iv-step {\n  width: 30px;\n  align-self: stretch;\n  border: none;\n  background: #fff;\n  color: #6f6a60;\n  font-size: 15px;\n  line-height: 1;\n  cursor: pointer;\n}\n.iv-step:hover {\n  background: #f6f4ef;\n  color: #191714;\n}\n.iv-day input {\n  border: none;\n  outline: none;\n  background: none;\n  height: 100%;\n  padding: 0 8px;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  border-left: 1px solid #f0ece3;\n  border-right: 1px solid #f0ece3;\n  width: 124px;\n}\n.iv-day input::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.5;\n}\n.iv-day input::-webkit-calendar-picker-indicator:hover {\n  opacity: 0.9;\n}\n.iv-today {\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  color: #4a453c;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n}\n.iv-today:hover:not(:disabled) {\n  background: #f6f4ef;\n}\n.iv-today:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.iv-search {\n  height: 34px;\n  min-width: 190px;\n  flex-grow: 1;\n  max-width: 300px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.iv-search:focus-within {\n  border-color: #d8c9a4;\n}\n.iv-search input {\n  border: none;\n  outline: none;\n  background: none;\n  width: 100%;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.iv-search-icon {\n  width: 11px;\n  height: 11px;\n  border: 1.6px solid #a29b8d;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n}\n.iv-search-icon::after {\n  content: \"\";\n  position: absolute;\n  right: -4px;\n  bottom: -3px;\n  width: 5px;\n  height: 1.6px;\n  background: #a29b8d;\n  transform: rotate(45deg);\n}\n\n/* ---------------- body ---------------- */\n.iv-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 18px 28px 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.iv-headline {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n.iv-headline-main {\n  min-width: 0;\n}\n.iv-eyebrow {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.iv-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 25px;\n  font-weight: 400;\n  line-height: 1.15;\n  color: #191714;\n  margin: 2px 0 0;\n}\n.iv-title-rel {\n  font-size: 12.5px;\n  color: #8b8477;\n  margin: 3px 0 0;\n}\n\n/* three totals that answer \"how much do I buy\" without adding the\n   column up by hand */\n.iv-kpis {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.iv-kpi {\n  min-width: 120px;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 11px;\n  padding: 9px 14px;\n}\n.iv-kpi-k {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.iv-kpi-v {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 23px;\n  line-height: 1.15;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  margin-top: 1px;\n}\n.iv-kpi-v small {\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  color: #a29b8d;\n  margin-left: 3px;\n}\n.iv-kpi-sub {\n  font-size: 11px;\n  color: #a29b8d;\n  margin-top: 1px;\n  overflow-wrap: anywhere;\n}\n\n/* The legacy caution box was a red sentence in a plain shadow box. It is\n   the one thing on this page that can make the numbers wrong, so it says\n   what to do about it. */\n.iv-warn {\n  flex-shrink: 0;\n  display: flex;\n  gap: 11px;\n  padding: 11px 14px;\n  border-radius: 11px;\n  background: #f9f1de;\n  border: 1px solid #ecdcb4;\n}\n.iv-warn-ic {\n  flex-shrink: 0;\n  font-size: 17px;\n  color: #b0872f;\n  line-height: 1.3;\n}\n.iv-warn-t {\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--rf-brand-deep);\n}\n.iv-warn-t b {\n  font-weight: 700;\n}\n.iv-warn-link {\n  border: none;\n  background: none;\n  padding: 0;\n  font: inherit;\n  color: var(--rf-brand);\n  border-bottom: 1px solid #d9c79c;\n  cursor: pointer;\n}\n.iv-warn-link:hover {\n  color: var(--rf-brand-hover);\n  border-bottom-color: var(--rf-brand);\n}\n\n/* ---------------- table ---------------- */\n.iv-tablewrap {\n  flex-grow: 1;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 14px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n.iv-scroll {\n  flex-grow: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n.iv-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.iv-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #474339;\n  color: #f2efe8;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  text-align: left;\n  padding: 9px 14px;\n  white-space: nowrap;\n  border: none;\n}\n.iv-sort {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.iv-sort:hover {\n  color: #fff;\n}\n.iv-sort-ar {\n  font-size: 9px;\n  opacity: 0.85;\n}\n.iv-sort.is-off .iv-sort-ar {\n  visibility: hidden;\n}\n.iv-table tbody td {\n  padding: 9px 14px;\n  border-bottom: 1px solid #f0ece3;\n  color: #4a453c;\n  vertical-align: middle;\n}\n.iv-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.iv-row:hover > td {\n  background: #fdfbf6;\n}\n.iv-c-num {\n  width: 46px;\n  text-align: right;\n  color: #bdb6a7;\n  font-size: 11.5px;\n  font-variant-numeric: tabular-nums;\n}\n.iv-c-name {\n  font-weight: 600;\n  color: #191714;\n  overflow-wrap: anywhere;\n}\n.iv-c-qty {\n  width: 90px;\n  text-align: right;\n  font-weight: 700;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n/* the share bar makes the two or three flowers that dominate the day\n   obvious without reading every number */\n.iv-c-share {\n  width: 34%;\n  min-width: 130px;\n}\n.iv-track {\n  height: 7px;\n  border-radius: 999px;\n  background: #f0ece3;\n  overflow: hidden;\n}\n.iv-track > span {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  background: var(--rf-brand-lite);\n}\n.iv-row.is-top .iv-track > span {\n  background: var(--rf-brand);\n}\n.iv-pct {\n  font-size: 10.5px;\n  color: #bdb6a7;\n  font-variant-numeric: tabular-nums;\n  margin-top: 3px;\n  display: block;\n}\n\n.iv-foot {\n  border-top: 1px solid #f0ece3;\n  background: #fdfcfa;\n  padding: 9px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  font-size: 11.5px;\n  color: #a29b8d;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------------- states ---------------- */\n.iv-state {\n  padding: 44px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: #8b8477;\n  line-height: 1.6;\n}\n.iv-state b {\n  display: block;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #4a453c;\n  margin-bottom: 3px;\n}\n.iv-state .rf-btn {\n  margin-top: 12px;\n}\n.iv-skel {\n  height: 13px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #f2efe8 25%, #f8f6f1 50%, #f2efe8 75%);\n  background-size: 300% 100%;\n  animation: iv-shimmer 1.3s linear infinite;\n}\n@keyframes iv-shimmer {\n  from {\n    background-position: 150% 0;\n  }\n  to {\n    background-position: -150% 0;\n  }\n}\n\n@media (max-width: 860px) {\n  .iv-bar,\n  .iv-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .iv-c-share {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
